var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgrammingArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17 3.74993H13.07L14.48 2.57995C14.8 2.30995 14.84 1.83995 14.58 1.51995C14.31 1.19995 13.84 1.15992 13.52 1.41992L10.52 3.91992C10.35 4.05992 10.25 4.26993 10.25 4.49993C10.25 4.72993 10.35 4.92995 10.52 5.07995L13.52 7.57995C13.66 7.69995 13.83 7.74993 14 7.74993C14.21 7.74993 14.43 7.65991 14.58 7.47991C14.85 7.15991 14.8 6.68992 14.48 6.41992L13.07 5.24993H17C17.69 5.24993 18.25 5.80993 18.25 6.49993V15.9999C18.25 16.4099 18.59 16.7499 19 16.7499C19.41 16.7499 19.75 16.4099 19.75 15.9999V6.49993C19.75 4.97993 18.52 3.74993 17 3.74993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16C17.3431 16 16 17.3431 16 19C16 20.6569 17.3431 22 19 22Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.48 18.92L10.48 16.42C10.16 16.15 9.69001 16.2 9.42001 16.52C9.15001 16.84 9.19999 17.31 9.51999 17.58L10.93 18.75H7C6.31 18.75 5.75 18.19 5.75 17.5V8C5.75 7.59 5.41 7.25 5 7.25C4.59 7.25 4.25 7.59 4.25 8V17.5C4.25 19.02 5.48 20.25 7 20.25H10.93L9.51999 21.42C9.19999 21.69 9.16001 22.16 9.42001 22.48C9.57001 22.66 9.78 22.75 10 22.75C10.17 22.75 10.34 22.69 10.48 22.58L13.48 20.08C13.65 19.94 13.75 19.73 13.75 19.5C13.75 19.27 13.65 19.07 13.48 18.92Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C6.65685 8 8 6.65685 8 5C8 3.34315 6.65685 2 5 2C3.34315 2 2 3.34315 2 5C2 6.65685 3.34315 8 5 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammingArrows);
export default __webpack_public_path__ + "static/media/programming-arrows.6e96b59a490aa30d28cfb40090858e69.svg";
export { ForwardRef as ReactComponent };